import { LeadSource } from './lead-source';
import {Model} from './model';
import { Partner } from './partner';
import {Unserializer} from './serialization';

export class Client implements Model {
  clientId: number;
  country: string;
  businessId: string;
  name: string;
  prepaymentRegisterCheckDate?: Date;
  responsibleSeller?: Partner;
  responsibleSellerId?: number;
  leadProvider?: Partner;
  leadProviderId?: number;
  leadSource?: LeadSource;
  leadSourceId?: number;
  created: Date;

  static copy(oldObj: Client): Client {
    const newObj = new Client();
    newObj.clientId = oldObj.clientId;
    newObj.country = oldObj.country;
    newObj.businessId = oldObj.businessId;
    newObj.name = oldObj.name;
    newObj.prepaymentRegisterCheckDate = Unserializer.date(oldObj.prepaymentRegisterCheckDate);
    newObj.responsibleSeller = oldObj.responsibleSeller;
    newObj.responsibleSellerId = oldObj.responsibleSellerId;
    newObj.leadProvider = oldObj.leadProvider;
    newObj.leadProviderId = oldObj.leadProviderId;
    newObj.leadSource = oldObj.leadSource;
    newObj.leadSourceId = oldObj.leadSourceId;
    newObj.created = Unserializer.date(oldObj.created);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.clientId;
  }

  isNew(): boolean {
    return isNaN(this.clientId);
  }

  clone(): Client {
    return Client.copy(this);
  }
}
